export default __webpack_public_path__ + "static/media/about-lg-leaf2.9dc125fb.svg";